import {useEffect, useRef} from "react";
import {useApiAuthCheckMobile, useApiAuthOtp} from "@/api/auth";
import {toast} from "react-toastify";
import {formatMobileNumber} from "@/lib/utils/number";

import {Button, Card, Input} from "antd";
import {Label} from "@/components/ui/label";
import AuthCardHeaderSection from "@/pages/auth/_section/AuthCardHeaderSection";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

export default function StateCheckMobileSection({changeMyState, setMyMobile, setMyData}) {

    let mobileRef = useRef(null);
    const {mutate: CheckMobile, isPendingCheck} = useApiAuthCheckMobile()
    const {mutate: AuthSendOtp, isPending} = useApiAuthOtp()

    const loginModel = 'LoginByOtp'; // LoginByPassword

    useEffect(() => {
        mobileRef.current.focus();
    }, [])


    function submitForm() {

        if (!mobileRef.current.input.value) {
            toast.error('لطفا تلفن همراه یا کدملی خود را وارد کنید')
            mobileRef.current.focus()
            return;
        }
        setMyMobile(mobileRef.current.input.value)

        if (loginModel === 'LoginByOtp') {

            AuthSendOtp({
                mobile: formatMobileNumber(mobileRef.current.input.value),
            }, {
                onSuccess: (data) => {
                    setMyData({
                        otpToken: data?.data?.data?.otp_token,
                        callFrom: 'loginRegisterByOtp'
                    })

                    changeMyState('otp')
                }, onError: (error) => {
                    ApiHandleErrorMessage(error);
                }
            })

        } else {
            CheckMobile({
                    mobile: formatMobileNumber(mobileRef.current.input.value),
                },
                {
                    onSuccess: (data) => {
                        if (data?.response_code === "CHECK_USER_EXISTS") {
                            changeMyState('login')
                        } else {
                            if (data?.response_code === "CHECK_USER_NOT_EXISTS") {
                                changeMyState('register')
                            } else {
                                toast.error('با عرض پوزش در حال حاضر مشکلی پیش آمده است. لطفا چند دقیقه بعد مجددا تلاش کنید')
                            }
                        }
                    }, onError: (error) => {
                        ApiHandleErrorMessage(error);
                    },

                })
        }


    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submitForm()
        }
    };

    return (
        <Card>
            <AuthCardHeaderSection title={'خوش آمدید'}
                                   description={<>
                                       <div>
                                           برای ورود یا ثبت‌نام لطفا شماره تلفن همراه خود را وارد کنید
                                       </div>
                                       <div>
                                           اگر قبلا ثبت‌نام کرد‌ه‌اید می‌توانید از کدملی برای ورود استفاده کنید
                                       </div>

                                   </>}/>

            <div className={'mt-4'}>
                <div className="flex flex-col gap-6">
                    <div className="grid gap-2">
                        <Label htmlFor="mobile">موبایل (یا کدملی برای کاربران ثبت نام کرده)</Label>
                        <Input
                            maxLength={12}
                            rootClassName={'ltr'}
                            disabled={isPending}
                            ref={mobileRef}
                            id="mobile"
                            style={{direction: 'ltr'}}
                            autoComplete="off"
                            onKeyDown={handleKeyDown}
                            type="tel"
                            placeholder="0912..." required/>
                    </div>
                    <Button

                        loading={isPending}
                        onClick={() => submitForm()}
                        type="primary" className="w-full">
                        ورود / ثبت‌نام
                    </Button>
                </div>
            </div>
        </Card>

    );
}
